import { render, staticRenderFns } from "./filters-drawer.vue?vue&type=template&id=2d4a8fd4&"
import script from "./filters-drawer.vue?vue&type=script&lang=js&"
export * from "./filters-drawer.vue?vue&type=script&lang=js&"
import style0 from "./filters-drawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4a8fd4')) {
      api.createRecord('2d4a8fd4', component.options)
    } else {
      api.reload('2d4a8fd4', component.options)
    }
    module.hot.accept("./filters-drawer.vue?vue&type=template&id=2d4a8fd4&", function () {
      api.rerender('2d4a8fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/filters/filters-drawer.vue"
export default component.exports